export const LossTypeFields = {
  TOTAL: 'total_loss',
  AVERAGE: 'avg_loss',
}

export const LossTypeChoices = [
  { text: 'Weighted Average', value: LossTypeFields.TOTAL },
  { text: 'Unweighted Average', value: LossTypeFields.AVERAGE },
]

export const LossSeasons = {
  WINTER: 'Winter',
  SUMMER: 'Summer',
  ANNUAL: 'Annual',
}

export const LossSeasonChoices = [
  { text: 'Winter', value: LossSeasons.WINTER },
  { text: 'Summer', value: LossSeasons.SUMMER },
  { text: 'Annual', value: LossSeasons.ANNUAL },
]

export const MSOCalcTypes = {
  MSO_IN: 'MSO in',
  MSO_OUT: 'MSO out',
  MSO_ONLY: 'MSO only',
}

export const msoCalcTypeChoices = [
  { text: 'All', value: MSOCalcTypes.MSO_IN },
  { text: 'Multiple State Only', value: MSOCalcTypes.MSO_ONLY },
  { text: 'Single State Only', value: MSOCalcTypes.MSO_OUT },
]


export const YearChoices = [
  ['2008', '2007/08'],
  ['2009', '2008/09'], ['2010', '2009/10'],
  ['2011', '2010/11'], ['2012', '2011/12'],
  ['2013', '2012/13'], ['2014', '2013/14'],
  ['2015', '2014/15'], ['2016', '2015/16'],
  ['2017', '2016/17'], ['2018', '2017/18'],
  ['2019', '2018/19'], ['2020', '2019/20'],
  ['2021', '2020/21'], ['2022', '2021/22'],
  ['2023', '2022/23']
]


/**
 * honeycomb Map Coordinates - contains coordinates for hexagons that 
 * represent a US map in Highcharts Tilemap. hc-a2 is the state 
 * abbreviation.  'name' is the full state name. x and y are the 
 * coordinates to place the hex on the chart/map. 'value' is the value 
 * for the state and usually represents a percentage for the state.
*/
export const honeycombMapCoordinates = 
[
  
  {
  'hc-a2': 'AL',
  name: 'Alabama',
  region: 'South',
  x: 6,
  y: 7,
  value: 0
  }, {
  'hc-a2': 'AK',
  name: 'Alaska',
  region: 'West',
  x: 0,
  y: 0,
  value: 0
  }, {
  'hc-a2': 'AZ',
  name: 'Arizona',
  region: 'West',
  x: 6,
  y: 3,
  value: 0
  }, {
  'hc-a2': 'AR',
  name: 'Arkansas',
  region: 'South',
  x: 5,
  y: 6,
  value: 0
  }, {
  'hc-a2': 'CA',
  name: 'California',
  region: 'West',
  x: 5,
  y: 2,
  value: 0
  }, {
  'hc-a2': 'CO',
  name: 'Colorado',
  region: 'West',
  x: 4,
  y: 3,
  value: 0
  }, {
  'hc-a2': 'CT',
  name: 'Connecticut',
  region: 'Northeast',
  x: 3,
  y: 11,
  value: 0
}, {
  'hc-a2': 'DE',
  name: 'Delaware',
  region: 'South',
  x: 4,
  y: 10,
  value: 0
  }, {
  'hc-a2': 'DC',
  name: 'District of Columbia',
  region: 'South',
  x: 5,
  y: 10,
  value: 0
  }, {
  'hc-a2': 'FL',
  name: 'Florida',
  region: 'South',
  x: 7,
  y: 8,
  value: 0
  }, {
  'hc-a2': 'GA',
  name: 'Georgia',
  region: 'South',
  x: 6,
  y: 8,
  value: 0
  }, 
  //  Currently Hawaii is included in Non Continental USA
  //{
  //'hc-a2': 'HI',
  //name: 'Hawaii',
  //region: 'West',
  //x: 6,
  //y: -1,
  //value: 0
  //}, 
  {
  'hc-a2': 'ID',
  name: 'Idaho',
  region: 'West',
  x: 3,
  y: 2,
  value: 0
  }, {
  'hc-a2': 'IL',
  name: 'Illinois',
  region: 'Midwest',
  x: 3,
  y: 6,
  value: 0
  }, {
  'hc-a2': 'IN',
  name: 'Indiana',
  region: 'Midwest',
  x: 3,
  y: 7,
  value: 0
  }, {
  'hc-a2': 'IA',
  name: 'Iowa',
  region: 'Midwest',
  x: 3,
  y: 5,
  value: 0
  }, {
  'hc-a2': 'KS',
  name: 'Kansas',
  region: 'Midwest',
  x: 5,
  y: 5,
  value: 0
  }, {
  'hc-a2': 'KY',
  name: 'Kentucky',
  region: 'South',
  x: 4,
  y: 6,
  value: 0
  }, {
  'hc-a2': 'LA',
  name: 'Louisiana',
  region: 'South',
  x: 6,
  y: 5,
  value: 0
  }, {
  'hc-a2': 'ME',
  name: 'Maine',
  region: 'Northeast',
  x: 0,
  y: 11,
  value: 0
  }, {
  'hc-a2': 'MD',
  name: 'Maryland',
  region: 'South',
  x: 4,
  y: 9,
  value: 0
  }, {
  'hc-a2': 'MA',
  name: 'Massachusetts',
  region: 'Northeast',
  x: 2,
  y: 10,
  value: 0
  }, {
  'hc-a2': 'MI',
  name: 'Michigan',
  region: 'Midwest',
  x: 2,
  y: 7,
  value: 0
  }, {
  'hc-a2': 'MN',
  name: 'Minnesota',
  region: 'Midwest',
  x: 2,
  y: 4,
  value: 0
  }, {
  'hc-a2': 'MS',
  name: 'Mississippi',
  region: 'South',
  x: 6,
  y: 6,
  value: 0
  }, {
  'hc-a2': 'MO',
  name: 'Missouri',
  region: 'Midwest',
  x: 4,
  y: 5,
  value: 0
  }, {
  'hc-a2': 'MT',
  name: 'Montana',
  region: 'West',
  x: 2,
  y: 2,
  value: 0
  }, {
  'hc-a2': 'NE',
  name: 'Nebraska',
  region: 'Midwest',
  x: 4,
  y: 4,
  value: 0
}, {
  'hc-a2': 'NV',
  name: 'Nevada',
  region: 'West',
  x: 4,
  y: 2,
  value: 0
}, {
  'hc-a2': 'NH',
  name: 'New Hampshire',
  region: 'Northeast',
  x: 1,
  y: 11,
  value: 0
}, {
  'hc-a2': 'NJ',
  name: 'New Jersey',
  region: 'Northeast',
  x: 3,
  y: 10,
  value: 0
}, {
  'hc-a2': 'NM',
  name: 'New Mexico',
  region: 'West',
  x: 5,
  y: 4,
  value: 0
  }, {
  'hc-a2': 'NY',
  name: 'New York',
  region: 'Northeast',
  x: 2,
  y: 9,
  value: 0
  }, {
  'hc-a2': 'NC',
  name: 'North Carolina',
  region: 'South',
  x: 5,
  y: 8,
  value: 0
  }, {
  'hc-a2': 'ND',
  name: 'North Dakota',
  region: 'Midwest',
  x: 2,
  y: 3,
  value: 0
  }, {
  'hc-a2': 'OH',
  name: 'Ohio',
  region: 'Midwest',
  x: 3,
  y: 8,
  value: 0
  }, {
  'hc-a2': 'OK',
  name: 'Oklahoma',
  region: 'South',
  x: 6,
  y: 4,
  value: 0
  }, {
  'hc-a2': 'OR',
  name: 'Oregon',
  region: 'West',
  x: 4,
  y: 1,
  value: 0
  }, {
  'hc-a2': 'PA',
  name: 'Pennsylvania',
  region: 'Northeast',
  x: 3,
  y: 9,
  value: 0
  }, {
  'hc-a2': 'RI',
  name: 'Rhode Island',
  region: 'Northeast',
  x: 2,
  y: 11,
  value: 0
  }, {
  'hc-a2': 'SC',
  name: 'South Carolina',
  region: 'South',
  x: 5,
  y: 9,
  value: 0
}, {
  'hc-a2': 'SD',
  name: 'South Dakota',
  region: 'Midwest',
  x: 3,
  y: 4,
  value: 0
  }, {
  'hc-a2': 'TN',
  name: 'Tennessee',
  region: 'South',
  x: 5,
  y: 7,
  value: 0
  }, {
  'hc-a2': 'TX',
  name: 'Texas',
  region: 'South',
  x: 7,
  y: 5,
  value: 0
  }, {
  'hc-a2': 'UT',
  name: 'Utah',
  region: 'West',
  x: 5,
  y: 3,
  value: 0
  }, {
  'hc-a2': 'VT',
  name: 'Vermont',
  region: 'Northeast',
  x: 1,
  y: 10,
  value: 0
  }, {
  'hc-a2': 'VA',
  name: 'Virginia',
  region: 'South',
  x: 4,
  y: 8,
  value: 0
  }, {
  'hc-a2': 'WA',
  name: 'Washington',
  region: 'West',
  x: 2,
  y: 1,
  value: 0
  }, {
  'hc-a2': 'WV',
  name: 'West Virginia',
  region: 'South',
  x: 4,
  y: 7,
  value: 0
  }, {
  'hc-a2': 'WI',
  name: 'Wisconsin',
  region: 'Midwest',
  x: 2,
  y: 5,
  value: 0
  }, {
  'hc-a2': 'WY',
  name: 'Wyoming',
  region: 'West',
  x: 3,
  y: 3,
  value: 0
  }, {
    'hc-a2': 'NCUSA',
    name: 'Non Continental USA',
    region: 'Non Continental USA',
    x: 8,
    y: 0,
    value: 0
  }, {
    'hc-a2': 'MSO',
    name: 'MultiStates',
    region: 'MultiStates',
    x: 8,
    y: -1,
    value: 0
  }
]

 